import { Frame, store } from '@/store';
import { download } from '@/utils/file';
import { deg2rad, EquatorialCoord } from '@hscmap/angle';
import { CameraMode, ConstellationLayer } from '@hscmap/stellar-globe';
import Vue from 'vue';
import { Component } from "vue-property-decorator";
import { canvasDafeDatUrl } from '@/utils/canvas';

@Component
export default class extends Vue {
  get modules(): Frame["modules"] {
    return store.currentFrame.modules
  }

  get constellationLang() {
    return ConstellationLayer.LANG
  }

  toggleMode() {
    const nextMode = ((): CameraMode => {
      switch (store.currentFrame.cameraMode) {
        case CameraMode.GNOMONIC:
          return CameraMode.STEROGRAPHIC
        case CameraMode.STEROGRAPHIC:
          return CameraMode.FLOATING_EYE
        default:
          return CameraMode.GNOMONIC
      }
    })()
    store.currentFrame.cameraMode = nextMode
  }

  zoom(fovy: number) {
    fovy /= 2
    const globe = store.currentGlobe()
    globe.viewFactory.jumpTo({ fovy })
  }

  zenithUp() {
    const globe = store.currentGlobe()
    globe.viewFactory.jumpTo({ roll: 0 })
  }

  deg2rad(deg: number) {
    return deg2rad(deg)
  }

  exportToPng() {
    const globe = store.currentGlobe()
    const url = canvasDafeDatUrl(globe.canvas.domElement)
    download(`hscMap.png`, url)
  }

  exportToJpg() {
    const globe = store.currentGlobe()
    const url = canvasDafeDatUrl(globe.canvas.domElement, 'image/jpeg')
    download(`hscMap.jpg`, url)
  }

  goto() {
    const vf = store.currentGlobe().viewFactory
    const current = vf.center()
    let input = prompt(coordFormat(this), `${current.a.deg} ${current.d.deg}`)
    if (input) {
      input = input.trim()
      if (input !== '') {
        if (input.match(/^tract\s*=\s*(\d+)\s*$/)) {
          const tractIndex = Number(RegExp.$1)
          store.modules.tract.goto(tractIndex)
          if (!store.modules.tract.show) {
            store.modules.tract.show = true
            setTimeout(() => store.modules.tract.show = false, 5000)
          }
          return
        }
        try {
          const coord = EquatorialCoord.parse(input!)
          vf.jumpTo({}, { coord })
        } catch (e) {
          alert(`Parse Error: ${e}`)
        }
      }
    }
  }
}

function coordFormat(vm: Vue) {
  console.log(vm.$i18n.locale)
  return vm.$i18n.locale === 'ja' ?
    `
書式:

  $ra $dec
  150.0903 2.2103
    または
  10:00:21.67 +02:12:37.19

  tract=$tract
  tract=9813
`
    : `
format:

  $ra $dec
  150.0903 2.2103
    OR
  10:00:21.67 +02:12:37.19

  tract=$tract
  tract=9813
`
}
